export default [
    {
        path: "/tributos/list",
        name: "listTributos",
        component: () =>
            import(/* webpackChunkName: "gestionTributos" */ "./views/listTributos.vue"),
    }
]